module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("First Mariner Books edition 2015")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Copyright © 2014 by Eric Lichtblau")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Lichtblau, Eric.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("The Nazis next door : how America became a safe haven for Hitler’s men / Eric Lichtblau.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-66919-9 (hardback) "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-57788-6 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1. Anti-communist movements—United States—History—20th century. 2. Nazis—United States—History—20th century. 3. Refugees—United States—History—20th century. 4. War criminals—United States—History—20th century. 5. United States. Federal Bureau of Investigation—History—20th century. 6. United States. Central Intelligence Agency—History—20th century. 7. Espionage, American—History—20th century. 8. Cold War. 9. United States—Politics and government—1945–1989. 10. United States—Foreign relations—1945–1989. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("E743.5.L49 2014")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("324.1'3—dc23 2014023543")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Map by Chris Robinson")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover design by Martha Kennedy")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover photograph © Christoph Goedan/Stern/laif/Redux Pictures")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-66922-9"), _c('br'), _vm._v("\nv3.1120")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0